import { useState, useCallback } from 'react'

import { authHeader, notifyError, notifySuccess } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useSetMaintenanceText = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)

  const setMaintenanceText = useCallback(async message => {
    setError(null)
    setLoading(true)
    try {
      await refreshToken()
      const url = new URL(`${REACT_APP_API_URL}/system/maintenance/message`)
      const options = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
      }
      const response = await fetch(url, options)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `HTTP ${response.status}`)
      }
      const result = await response.json().catch(() => null)

      notifySuccess('Wartungsmeldung aktualisiert')
      return result
    } catch (error) {
      const errMsg =
        error?.message || 'Fehler beim Aktualisieren der Wartungsmeldung'
      setError(errMsg)

      notifyError(errMsg)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { setMaintenanceText, isLoading, isError }
}
